require('./base-integration');
const shellModule = require('@edreamsodigeo/frontend-shell');

module.exports = shellModule.legacyShell;
